import * as React from 'react';
import classNames from 'classnames';

import * as _ from 'lodash-es';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import SvgAddIcon from '../../static/icons/svgAddIcon';

import { hasPermission } from '../../helpers/Permission';
import { PermissionTypes } from '../../constants';
import styles from './styles.pcss';

class AgencyTableHead extends React.Component<any> {
  render() {
    return (
      <TableHead>
        <TableRow>
          <TableCell className={classNames(styles.tableHead)}>Name</TableCell>
          <TableCell className={classNames(styles.tableHead)}>
            App URL
          </TableCell>
          <TableCell className={classNames(styles.tableHead)}>
            {hasPermission('agency', PermissionTypes.create) && (
              <div
                onClick={this.props.onClickAddAgency}
                className={classNames(styles.addAgency)}
              >
                <div className={classNames(styles.addIcon)}>
                  <SvgAddIcon
                    width={18}
                    height={18}
                  />
                </div>
                <div>Add Agency</div>
              </div>
            )}
          </TableCell>
        </TableRow>
      </TableHead>
    );
  }
}

export default AgencyTableHead;
